import { FormControl } from "@angular/forms";

export function noWhitespaceValidator(control: FormControl) {
  return control.value && control.value.trim().length
    ? null
    : !control.value
    ? null
    : { whitespace: true };
}
